import React from "react";
import { BaseListItemIcon, ListItemWrapperIcon } from "./style";
import PropTypes from "prop-types";
import styled from "styled-components";
import Avatar from "components/common/Avatar";
import { SIZE } from "constant";

ListItemAvatar.propTypes = {
  label: PropTypes.string,
  imgSrc: PropTypes.string,
  size: PropTypes.oneOf([
    SIZE.small,
    SIZE.xxl,
    SIZE._3xl,
    SIZE._4xl,
    SIZE._5xl,
    SIZE._6xl,
    SIZE._7xl,
    SIZE._8xl,
    SIZE._9xl,
    SIZE._10xl,
  ]),
};
ListItemAvatar.defaultProps = {
  label: null,
};

export default function ListItemAvatar(props) {
  if (props.label) {
    return (
      <ListItemWrapperIcon>
        <BaseListItemIcon cursor="defualt">
          <Avatar
            label={props.label}
            size={props.size}
            imgSrc={props.imgSrc}
          ></Avatar>
        </BaseListItemIcon>
      </ListItemWrapperIcon>
    );
  } else {
    return (
      <BaseListItemIcon>
        <EmptyIcon></EmptyIcon>
      </BaseListItemIcon>
    );
  }
}

const EmptyIcon = styled.div`
  width: 14px;
  height: 14px;
`;
